<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.agentId"
        placeholder="请选择"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in daiList"
          :key="item.id"
          :label="item.agentName"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.teamLogo"
        placeholder="团队标识"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in TEAM_LOGO_ENUM"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-input
        v-model="listQuery.agentMobile"
        placeholder="代理商电话"
        style="width: 300px"
        class="filter-item"
        clearable
      />

      <el-input
        v-model="listQuery.partnerMobile"
        placeholder="合伙人电话"
        style="width: 300px"
        class="filter-item"
        clearable
      />

      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column label="代理名称" align="center" prop="agentName"></el-table-column>
      <!-- <el-table-column align="center" prop="agentId" label="代理ID" width="120px"></el-table-column> -->
      <el-table-column label="代理用户名称" align="center" prop="agentUserName"></el-table-column>
      <!-- <el-table-column label="代理用户ID" align="center" prop="agentUserId" width="120px"></el-table-column> -->
      <el-table-column label="代理合伙人用户" align="center" prop="partnerUser"></el-table-column>
      <el-table-column
        label="代理合伙人用户ID"
        align="center"
        prop="partnerUserId"
        width="120px"
      ></el-table-column>

      <el-table-column align="center" prop="ration" label="分红比例" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.ration ? scope.row.ration * 100 + "%" : "-" }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="ctdate" label="创建时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="onBo(scope.row)" class="comm_but_warp"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog :visible.sync="isBo" :append-to-body="true">
      <div class="dialog-view" v-if="curRow">
        <span style="font-size:30px;" class="dia-pos">修改代理合伙人比例</span>
        <div class="dialog-content">
          <div class="dialog-left">
            代理合伙人用户:
          </div>
          <div class="dialog-right">
            {{ curRow.partnerUser }}
          </div>
        </div>
        <div class="dialog-content" style="margin-top:20px">
          <div class="dialog-left">
            分红比例:
          </div>
          <div class="dialog-right">
            <el-input
              style="width: 200px"
              v-model="ration"
              placeholder="请输入"
              type="number"
              :min="0"
              :max="1"
              @input="handleRationInput"
            />
          </div>
        </div>
      </div>
      <el-button @click="onClose">取 消</el-button>
      <el-button type="primary" @click="onBoHui">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { getAgentPartnerList, updateAgentPartnerRatio } from "@/api/agent";
import { getAgentConfigList } from "@/api/regionAgent";
import { formatApiDate } from "@/utils/utils";
import { getValue, TEAM_LOGO_ENUM } from "@/utils/enumUtile";

export default {
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      isBo: false,
      listQuery: {
        page: 1,
        pageSize: 10,
        teamLogo: null,
        agentId: null,
        agentMobile: null,
        partnerMobile: null
      },
      curRow: null,
      ration: "",
      daiList: []
    };
  },
  created() {
    this.getList();
    this.getDai();
  },
  methods: {
    getValue,
    onBo(row) {
      this.curRow = row;
      this.isBo = true;
    },
    onBoHui() {
      let params = {
        id: this.curRow.id,
        ration: this.ration
      };
      updateAgentPartnerRatio(params).then(res => {
        this.$message.success("修改成功");
        this.getList();
        this.onClose();
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      getAgentPartnerList(this.listQuery).then(res => {
        this.list = res.data.entitys;
        this.total = res.data.totalCount;
        this.listLoading = false;
      });
    },
    onClose() {
      this.remark = "";
      this.curRow = null;
      this.isBo = false;
    },
    handleRationInput(val) {
      if (val === "" || val === null || val === undefined) {
        this.ration = "";
        return;
      }
      let valStr = String(val).replace(/[^\d.]/g, "");
      const parts = valStr.split(".");
      if (parts.length > 2) {
        valStr = parts[0] + "." + parts.slice(1).join("");
      }
      const num = parseFloat(valStr);
      if (!isNaN(num)) {
        if (num > 1) {
          valStr = "1";
        } else if (num < 0) {
          valStr = "0";
        }
      }
      this.ration = valStr;
      this.$nextTick(() => {
        this.ration = valStr;
      });
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    getDai() {
      this.listLoading = true;
      getAgentConfigList({ page: 1, pageize: 1000 }).then(res => {
        this.daiList = res.data.entitys;
        this.listLoading = false;
      });
    }
  },
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    TEAM_LOGO_ENUM() {
      return TEAM_LOGO_ENUM;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-view {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 30px;
  position: relative;

  .dialog-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .dialog-left {
      width: 200px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }

    .dialog-right {
      flex: 1;
      margin-left: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .dia-pos {
    position: absolute;
    top: -70px;
  }
}

.image-wrapper {
  position: relative;
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 8px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .download-btn {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(64, 158, 255, 0.9);
    border: none;
    color: #fff;
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 16px;
    opacity: 0;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      background: rgba(64, 158, 255, 1);
      transform: translateX(-50%) scale(1.05);
    }
  }

  &:hover .download-btn {
    opacity: 1;
  }
}

.upload-list {
  ::v-deep .upload_list_warp {
    .el-upload {
      width: 80px;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  ::v-deep .el-upload__tip {
    display: none;
  }
}
</style>
